import React, { useState } from "react";
import fbIcon from "../../assets/images/fb-icon.svg";
import instagramIcon from "../../assets/images/instagram-icon.svg";
import linkedinIcon from "../../assets/images/linkedin-icon.svg";
import youtubeIcon from "../../assets/images/youtube-icon.svg";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  FACEBOOK_URL_REGEX,
  INSTAGRAM_URL_REGEX,
  LINKEDIN_URL_REGEX,
  PAN_REGEX,
  REDIRECT_BASE_URL,
  YOUTUBE_URL_REGEX,
} from "../../config/constant";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../common/Footer";
import {
  RegisterStepFour,
  RegisterStepOne,
  RegisterStepThree,
  RegisterStepTwo,
} from "../../api/Register";
import { tostE, tostS, tostW } from "../../config/tostConfig";
import { setProcessData } from "../../redux/actions/processAction";
import { useLocation, useParams } from "react-router-dom";
import SaveAsDraftModal from "../common/SaveAsDraftModal";
import moment from "moment";
import { Modal } from "../ui";
import { pendingIcon } from "../../assets/images";
import useMemberValidation from "../../customHook/useMemberValidation";
import PdfConsentModal from "../PdfConsent/PdfConsentModal";
import tncPdf from "../../assets/pdf/tnc.pdf";

export default function OthersDetailsCp({
  handleBack = () => {},
  handleTab = () => {},
  setInValidForm = () => {},
}) {
  const { user_id } = useParams();
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();
  const { data, step, currentMembership } = useSelector(
    (state) => state.process
  );
  const [loading, setLoading] = useState("");
  const [draftSaved, setDraftSaved] = useState(false);
  const [draftError, setDraftError] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disclaimerAcknowledgement, setDisclaimerAcknowledgement] =
    useState(false);

  const [tncDoc] = useState(tncPdf);

  const [consentInfo, setConsentInfo] = useState({
    consent_checked: false,
    consent_popup: false,
    agree: false,
    error: false,
  });

  const members_validation_fields = [
    "member_name_1",
    "member_name_2",
    "member_email_1",
    "member_email_2",
    "member_mobile_1",
    "member_mobile_2",
    "member_director_1",
    "member_director_2",
    "signature_url",
    "stamp_url",
  ];

  const basicDetailValidation = [
    "name",
    "email",
    "dob",
    "mobile_number",
    "state",
    "zone",
    "gst_number",
    "aadhar_proof",
    "pan_proof",
    "pan_number",
    "org_type",
    "company_name",
    "registered_address",
    "size_of_company",
    "incorporation_date",
    "primary_number",
    "moa",
    "aoa",
    "portaldirector",
    "resolution",
    "incorporation_certificate",
    "repersentative_photo",
    "deed",
    "authorization",
    "huf_authorization",
    "address_proof",
    "turnover_certificate",
  ];

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email"),
    dob: Yup.string().required("Date of birth is required"),
    mobile_number: Yup.string()
      .required("Whatsapp number is required")
      .min(6, "Please enter a valid number"),
    primary_number: Yup.string()
      .required("Primary number is required")
      .min(6, "Please enter a valid number"),
    state: Yup.string().required("State is required"),
    zone: Yup.string().required("Zone is required"),
    registered_address: Yup.string().required(
      "Registered Office address is required"
    ),
    size_of_company: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("Size of company is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    incorporation_date: Yup.string().when(["org_type"], {
      is: (org_type) =>
        currentMembership &&
        currentMembership?.name.toLowerCase() !== "star" &&
        org_type &&
        org_type.toLowerCase() !== "huf",
      then: () => Yup.string().required("Incorporation date is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    // GST number optional if membership is star
    gst_number: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("GST number is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    aadhar_proof: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() === "star",
      then: () => Yup.string().required("Aadhar Card is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    pan_proof: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() === "star",
      then: () => Yup.string().required("PAN Card is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    pan_number: Yup.string()
      .required("PAN number is required")
      .matches(PAN_REGEX, "Please enter a valid PAN number"),
    org_type: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("Company type is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    company_name: Yup.string().required("Company name is required"),
    moa: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("MOA is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    aoa: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("AOA is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    portaldirector: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("Director Details is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    resolution: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () => Yup.string().required("Resolution is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    incorporation_certificate: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "company"
        );
      },
      then: () =>
        Yup.string().required("Incorporation certificate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    repersentative_photo: Yup.string().required(
      "Representative photo is required"
    ),
    deed: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "partnership"
        );
      },
      then: () => Yup.string().required("Deed is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    authorization: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "partnership"
        );
      },
      then: () => Yup.string().required("Authorization is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    huf_authorization: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return (
          currentMembership &&
          currentMembership?.name.toLowerCase() !== "star" &&
          org_type &&
          org_type.toLowerCase() === "huf"
        );
      },
      then: () => Yup.string().required("Authorization is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    address_proof: Yup.string().required("Address proof is required"),
    turnover_certificate: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("Turnover certificate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    director: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .nullable()
            .test("name-required-if-any", "Name is required", function (value) {
              const { email, mobile_number } = this.parent; // Access sibling fields
              return (
                (!email && !mobile_number) ||
                ((!!email || !!mobile_number) && !!value)
              ); // Name is required if email or mobile number exists
            }),
          email: Yup.string()
            .nullable()
            .email("Please enter a valid email")
            .test(
              "email-required-if-name",
              "Email is required",
              function (value) {
                const { name } = this.parent; // Access sibling fields
                return !name || (name && value); // Email is required if name exists
              }
            ),
          mobile_number: Yup.string()
            .nullable()
            .min(6, "Please enter a valid mobile number")
            .test(
              "mobile-required-if-name",
              "Mobile number is required",
              function (value) {
                const { name } = this.parent; // Access sibling fields
                return !name || (name && value); // Mobile number is required if name exists
              }
            ),
        })
      )
      .test(
        "unique-email",
        "Email addresses must be unique",
        function (values) {
          if (!values || !values.length) return true;
          const emails = values.map((item) => item.email).filter(Boolean);
          const uniqueEmails = new Set(emails);
          return emails.length === uniqueEmails.size;
        }
      )
      .test(
        "unique-mobile-number",
        "Mobile numbers must be unique",
        function (values) {
          if (!values || !values.length) return true;
          const mobileNumbers = values
            .map((item) => item.mobile_number)
            .filter(Boolean);
          const uniqueMobileNumbers = new Set(mobileNumbers);
          return mobileNumbers.length === uniqueMobileNumbers.size;
        }
      )
      .test(
        "not-users-email",
        "You can't use your email as director's Email address",
        function (values) {
          if (!values || !values.length) return true;
          const emails = values.map((item) => item.email).filter(Boolean);
          return !emails.includes(data.email);
        }
      )
      .test(
        "not-users-mobile-number",
        "You can't use your mobile number as director's mobile number",
        function (values) {
          if (!values || !values.length) return true;
          const mobileNumbers = values
            .map((item) => item.mobile_number)
            .filter(Boolean);
          return !mobileNumbers.includes(data.mobile_number);
        }
      ),
    member_name_1: Yup.string().required("Name is required"),
    member_name_2: Yup.string().required("Name is required"),
    member_director_1: Yup.string().required("Director Name is required"),
    member_director_2: Yup.string().required("Director Name is required"),
    member_email_1: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email")
      .test(
        "unique-email-1",
        "You can't use your email for eema members",
        function (value) {
          return value !== data.email; // Compare with user's email
        }
      )
      .test(
        "unique-between-emails",
        "Emails must be different",
        function (value) {
          return value !== this.parent.member_email_2; // Compare with member_email_2
        }
      ),
    member_email_2: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email")
      .test(
        "unique-email-2",
        "You can't use your email for eema members",
        function (value) {
          return value !== data.email; // Compare with user's email
        }
      )
      .test(
        "unique-between-emails",
        "Emails must be different",
        function (value) {
          return value !== this.parent.member_email_1; // Compare with member_email_1
        }
      ),
    member_mobile_1: Yup.string()
      .required("Mobile number is required")
      .min(6, "Please enter a valid mobile number")
      .max(15, "Please enter a valid mobile number")
      .test(
        "unique-mobile-1",
        "You can't use your mobile for eema members",
        function (value) {
          return value !== data.mobile_number; // Compare with user's mobile
        }
      )
      .test(
        "unique-between-mobiles",
        "Mobile numbers must be different",
        function (value) {
          return value !== this.parent.member_mobile_2; // Compare with member_mobile_2
        }
      ),
    member_mobile_2: Yup.string()
      .required("Mobile number is required")
      .min(6, "Please enter a valid mobile number")
      .max(15, "Please enter a valid mobile number")
      .test(
        "unique-mobile-2",
        "You can't use your mobile for eema members",
        function (value) {
          return value !== data.mobile_number; // Compare with user's mobile
        }
      )
      .test(
        "unique-between-mobiles",
        "Mobile numbers must be different",
        function (value) {
          return value !== this.parent.member_mobile_1; // Compare with member_mobile_1
        }
      ),
    signature_url: Yup.string().when([], {
      is: () =>
        currentMembership && currentMembership?.name.toLowerCase() !== "star",
      then: () => Yup.string().required("Signature is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    stamp_url: Yup.string()
      .when([], {
        is: () =>
          currentMembership && currentMembership?.name.toLowerCase() !== "star",
        then: () => Yup.string().required("Stamp is required"),
        otherwise: () => Yup.string().notRequired(),
      })
      .required("Stamp is required"),
    membership_checked: Yup.boolean()
      .oneOf([true], "Please accept t&c.")
      .required("Membership check is required"),

    description: Yup.string()
      .required("Description is required")
      .test(
        "min-words",
        "Description should be at least 100 words",
        (value) => value && value.trim().split(/\s+/).length >= 100
      )
      .test(
        "max-words",
        "Description should be less than 500 words",
        (value) => value && value.trim().split(/\s+/).length <= 500
      ),
    meta: Yup.string().matches(FACEBOOK_URL_REGEX, "Please enter a valid URL"),
    linkedin: Yup.string().matches(
      LINKEDIN_URL_REGEX,
      "Please enter a valid URL"
    ),
    instagram: Yup.string().matches(
      INSTAGRAM_URL_REGEX,
      "Please enter a valid URL"
    ),
    youtube: Yup.string().matches(
      YOUTUBE_URL_REGEX,
      "Please enter a valid URL"
    ),
  });

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      name: data.name ? data.name : "",
      email: data.email ? data.email : "",
      dob: data.dob ? data.dob : "",
      mobile_number: data.mobile_number ? data.mobile_number : "",
      state: data.state ? data.state : "",
      zone: data.zone ? data.zone : "",
      gst_number: data.gst_number ? data.gst_number : "",
      aadhar_proof: data.aadhar_proof ? data.aadhar_proof : "",
      pan_proof: data.pan_proof ? data.pan_proof : "",
      pan_number: data.pan_number ? data.pan_number : "",
      org_type: data.org_type ? data.org_type : "",
      company_name: data.company_name ? data.company_name : "",
      registered_address: data.registered_address
        ? data.registered_address
        : "",
      incorporation_date: data.incorporation_date
        ? data.incorporation_date
        : "",
      size_of_company: data.size_of_company ? data.size_of_company : "",
      primary_number: data.primary_number ? data.primary_number : "",
      same_number: data.same_number ? data.same_number : 0,
      moa: data.company && data.company.moa ? data.company.moa : "",
      aoa: data.company && data.company.aoa ? data.company.aoa : "",
      portaldirector:
        data.company && data.company.portaldirector
          ? data.company.portaldirector
          : "",
      resolution:
        data.company && data.company.resolution ? data.company.resolution : "",
      incorporation_certificate: data.incorporation_certificate
        ? data.incorporation_certificate
        : "",
      repersentative_photo: data.repersentative_photo
        ? data.repersentative_photo
        : "",
      deed: data.llp && data.llp.deed ? data.llp.deed : "",
      authorization:
        data.llp && data.llp.authorization ? data.llp.authorization : "",
      huf_deed: data.huf && data.huf.deed ? data.huf.deed : "",
      huf_authorization:
        data.huf && data.huf.authorization ? data.huf.authorization : "",
      address_proof: data.address_proof ? data.address_proof : "",
      turnover_certificate: data.turnover_certificate
        ? data.turnover_certificate
        : "",

      director: data.director ? data.director : "",

      member_name_1:
        data.members && data.members.length ? data.members[0].name : "",
      member_name_2:
        data.members && data.members.length ? data.members[1].name : "",
      member_email_1:
        data.members && data.members.length ? data.members[0].email : "",
      member_email_2:
        data.members && data.members.length ? data.members[1].email : "",
      member_mobile_1:
        data.members && data.members.length
          ? data.members[0].mobile_number
          : "",
      member_mobile_2:
        data.members && data.members.length
          ? data.members[1].mobile_number
          : "",
      member_director_1:
        data.members && data.members.length ? data.members[0].director : "",
      member_director_2:
        data.members && data.members.length ? data.members[1].director : "",
      signature: data.signature ? data.signature : "",
      signature_url: data.signature ? data.signature : "",
      stamp: data.stamp ? data.stamp : "",
      stamp_url: data.stamp ? data.stamp : "",

      description: data.description ? data.description : "",
      meta: data.meta ? data.meta : "",
      linkedin: data.linkedin ? data.linkedin : "",
      instagram: data.instagram ? data.instagram : "",
      youtube: data.youtube ? data.youtube : "",
      membership_checked: data.membership_checked === 1 ? true : false,
    },
    validationSchema,
    onSubmit: async (values) => {
      if (
        currentMembership &&
        currentMembership?.name.toLowerCase() === "star" &&
        (!values.gst_number ||
          values.gst_number.trim() === "" ||
          values.gst_number === null ||
          values.gst_number === "null") &&
        !disclaimerAcknowledgement
      ) {
        setShowDisclaimer(true);
        return;
      }
      setLoading("submit");
      const body = {
        id: data.id,
        description: values.description.trim(),
        meta: values.meta,
        linkedin: values.linkedin,
        instagram: values.instagram,
        youtube: values.youtube,
        is_draft: 0,
        is_admin: 1,
        journey: pathname.includes("upgrade") ? "upgrade" : "new",
        membership_checked: values.membership_checked ? 1 : 0,
      };

      if (data.app_id) {
        body.app_id = data.app_id;
      }

      try {
        const members = [
          {
            row_id: 1,
            name: values.member_name_1,
            email: values.member_email_1,
            mobile_number: values.member_mobile_1,
            director: values.member_director_1,
          },
          {
            row_id: 2,
            name: values.member_name_2,
            email: values.member_email_2,
            mobile_number: values.member_mobile_2,
            director: values.member_director_2,
          },
        ];
        // Basic Details Data
        let formData1 = new FormData();

        formData1.set("id", data.id);
        formData1.set("name", data.name);
        formData1.set("email", data.email);
        formData1.set("dob", moment(data.dob).format("YYYY-MM-DD"));
        formData1.set("mobile_number", data.mobile_number);
        formData1.set("pan_number", data.pan_number);
        formData1.set(
          "gst_number",
          data.gst_number &&
            data.gst_number !== null &&
            data.gst_number !== "null"
            ? data.gst_number
            : ""
        );
        formData1.set("zone", data.zone);
        formData1.set("state", data.state);
        formData1.set(
          "membership_id",
          currentMembership ? currentMembership.id : data.plan_history.plan_id
        );
        formData1.set("company_name", data.company_name);
        formData1.set("registered_address", data.registered_address);
        formData1.set("size_of_company", data.size_of_company);
        formData1.set("primary_number", data.primary_number);
        formData1.set("same_number", data.same_number);
        formData1.set("repersentative_photo", data.repersentative_photo);
        formData1.set("address_proof", data.address_proof);
        formData1.set("is_draft", 0);
        formData1.set("is_admin", 1);

        if (
          currentMembership &&
          currentMembership.name.toLowerCase() === "star"
        ) {
          formData1.set("aadhar_proof", data.aadhar_proof);
          formData1.set("pan_proof", data.pan_proof);
        }

        if (
          currentMembership &&
          currentMembership.name.toLowerCase() !== "star"
        ) {
          if (data.org_type) {
            formData1.set("org_type", data.org_type);
            formData1.set(
              "incorporation_date",
              moment(data.incorporation_date).format("YYYY-MM-DD")
            );
            formData1.set("turnover_certificate", data.turnover_certificate);
          }
          if (data.org_type && data.org_type.toLowerCase() === "company") {
            formData1.set("moa", data.company.moa);
            formData1.set("aoa", data.company.aoa);
            formData1.set("portaldirector", data.company.portaldirector);
            formData1.set("resolution", data.company.resolution);
            formData1.set(
              "incorporation_certificate",
              data.incorporation_certificate
            );
          }
          if (data.org_type && data.org_type.toLowerCase() === "partnership") {
            formData1.set("deed", data.llp.deed);
            formData1.set("authorization", data.llp.authorization);
          }
          if (values.org_type.toLowerCase() === "huf") {
            formData1.set("deed", data.huf.deed);
            formData1.set("authorization", data.huf.authorization);
          }
        }
        formData1.set("journey", data.history_type ? data.history_type : "new");
        if (data.app_id) {
          formData1.set("app_id", data.app_id);
        }
        // Membership Data
        const formData = new FormData();
        formData.set("id", data.id);
        formData.set("members", JSON.stringify(members));
        formData.set("old_signature", values.signature);
        formData.set("old_stamp", values.stamp);
        formData.set("is_draft", 0);
        formData.set("is_admin", 1);
        formData.set("journey", "upgrade");

        if (data.app_id) {
          formData.set("app_id", data.app_id);
        }

        // Directors Data
        const directorBody = {
          id: data.id,
          director:
            currentMembership && currentMembership.name.toLowerCase() !== "star"
              ? data.director?.filter(
                  (item) => item.name && item.email && item.mobile_number
                ).length
                ? data.director
                : null
              : null,
          is_draft: 0,
          is_admin: 1,
          journey: pathname.includes("upgrade") ? "upgrade" : "new",
        };

        if (data.app_id) {
          directorBody.app_id = data.app_id;
        }

        if (step < 4) {
          if (step < 2) {
            const res1 = await RegisterStepOne(formData1);
            if (res1.status === 200 && res1.data.success) {
              const res2 = await RegisterStepTwo(directorBody);
              if (res2.status === 200 && res2.data.success) {
                const res3 = await RegisterStepThree(formData);
                if (res3.status === 200 && res3.data.success) {
                  const res4 = await RegisterStepFour(body);
                  if (res4.status === 200 && res4.data.success) {
                    tostS(res4.data.message);
                    window.location.replace(
                      REDIRECT_BASE_URL +
                        search.replace("?user=", "") +
                        `?url=${encodeURIComponent(
                          "/members-list?success=true"
                        )}`
                    );
                  } else {
                    tostW(res4.data.message);
                  }
                }
              }
            }
          } else {
            const res2 = await RegisterStepTwo(directorBody);
            if (res2.status === 200 && res2.data.success) {
              const res3 = await RegisterStepThree(formData);
              if (res3.status === 200 && res3.data.success) {
                const res = await RegisterStepFour(body);
                if (res.status === 200 && res.data.success) {
                  tostS(res.data.message);
                  window.location.replace(
                    REDIRECT_BASE_URL +
                      search.replace("?user=", "") +
                      `?url=${encodeURIComponent("/members-list?success=true")}`
                  );
                } else {
                  tostW(res.data.message);
                }
              }
            }
          }
        } else {
          const res = await RegisterStepFour(body);
          if (res.status === 200 && res.data.success) {
            tostS(res.data.message);
            window.location.replace(
              REDIRECT_BASE_URL +
                search.replace("?user=", "") +
                `?url=${encodeURIComponent("/members-list?success=true")}`
            );
          } else {
            tostW(res.data.message);
          }
        }
      } catch (error) {
        tostE("Something went wrong");
        console.log(error);
      } finally {
        setLoading("");
      }
    },
  });

  const { isMemberDetailsValid } = useMemberValidation();

  const { values, errors, touched, getFieldProps, handleSubmit } = formik;

  return (
    <>
      <FormikProvider value={formik}>
        <Form onSubmit={handleSubmit}>
          <div className="membershipForm">
            <div className="form-group">
              <textarea
                className="form-control textarea"
                placeholder="Tell us about yourself/company in max 500 words"
                name="description"
                value={values.description}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();

                  formik.setFieldValue("description", e.target.value);
                  dispatch(setProcessData({ description: inputValue }));
                }}
              />
              <div
                className={
                  "d-flex justify-content-between" +
                  (values.description.trim().split(/\s+/).length > 500
                    ? " error"
                    : "")
                }
              >
                <span className="input-char-count">
                  {values.description
                    ? values.description.trim().split(/\s+/).length
                    : 0}
                  /
                  {values.description.trim().split(/\s+/).length <= 100
                    ? 100
                    : 500}
                </span>
                {values.description.trim().split(/\s+/).length > 500 && (
                  <span className="input-char-count">
                    {values.description.trim().split(/\s+/).length - 500} words
                    exceeded
                  </span>
                )}
              </div>
              {touched.description && errors.description && (
                <div className="error">{errors.description}</div>
              )}
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <div className="socialLinksInput">
                    <span className="icon">
                      <img src={fbIcon} alt="" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="https://"
                      name="meta"
                      value={values.meta}
                      onChange={(e) => {
                        formik.setFieldValue("meta", e.target.value);
                        dispatch(setProcessData({ meta: e.target.value }));
                      }}
                    />
                  </div>
                  {touched.meta && errors.meta && (
                    <div className="error">{errors.meta}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="socialLinksInput">
                    <span className="icon">
                      <img src={linkedinIcon} alt="" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="https://"
                      name="linkedin"
                      value={values.linkedin}
                      onChange={(e) => {
                        formik.setFieldValue("linkedin", e.target.value);
                        dispatch(setProcessData({ linkedin: e.target.value }));
                      }}
                    />
                  </div>
                  {touched.linkedin && errors.linkedin && (
                    <div className="error">{errors.linkedin}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="socialLinksInput">
                    <span className="icon">
                      <img src={instagramIcon} alt="" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="https://"
                      name="instagram"
                      value={values.instagram}
                      onChange={(e) => {
                        formik.setFieldValue("instagram", e.target.value);
                        dispatch(setProcessData({ instagram: e.target.value }));
                      }}
                    />
                  </div>
                  {touched.instagram && errors.instagram && (
                    <div className="error">{errors.instagram}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="socialLinksInput">
                    <span className="icon">
                      <img src={youtubeIcon} alt="" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="https://"
                      name="youtube"
                      value={values.youtube}
                      onChange={(e) => {
                        formik.setFieldValue("youtube", e.target.value);
                        dispatch(setProcessData({ youtube: e.target.value }));
                      }}
                    />
                  </div>
                  {touched.youtube && errors.youtube && (
                    <div className="error">{errors.youtube}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="form-check form-check-inline eligibleText">
              <input
                className="form-check-input"
                type="checkbox"
                id="inlineCheckbox1"
                name="membership_checked"
                checked={values.membership_checked}
                {...getFieldProps("membership_checked")}
              />
              <label className="form-check-label" htmlFor="inlineCheckbox1">
                I/We agree that all details submitted by us are true and
                correct. In case we do not meet the eligibility criteria for the
                Membership as stated in the terms, we would like to apply for
                the category of membership that we qualify for.
              </label>
              {touched.membership_checked && errors.membership_checked && (
                <p className="error">{errors.membership_checked}</p>
              )}
            </div>
            <div className="form-check form-check-inline eligibleText">
              <input
                className="form-check-input"
                type="checkbox"
                id="inlineCheckbox2"
                name="consent_checked"
                checked={consentInfo.consent_checked}
                onChange={(e) => {
                  setConsentInfo({
                    consent_checked: e.target.checked,
                    agree: false,
                    consent_popup: e.target.checked,
                    error: !e.target.checked,
                  });
                }}
              />
              <label className="form-check-label" htmlFor="inlineCheckbox2">
                I/We accept that I have read the EEMA HR Code of Conduct and
                WeCare PoSH Policy & would like the WeCare Pledge to be mailed
                to my/our registered email ID.
              </label>
              {consentInfo?.error && (
                <p className="error">Please accept t&c.</p>
              )}
            </div>
          </div>
        </Form>
      </FormikProvider>
      <Footer
        hideBackButton={user_id ? true : false}
        className={user_id ? "justify-content-end" : ""}
        isBackAllowed
        isNextAllowed={
          loading !== "submit" &&
          values.membership_checked &&
          consentInfo.consent_checked &&
          consentInfo.agree
        }
        isSaveAsDraft={false}
        backButtonAction={() => handleBack()}
        nextButtonText={() => (
          <>
            {loading === "submit" && (
              <div
                className="spinner-border text-secondary"
                style={{ width: "1rem", height: "1rem", marginRight: "5px" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
            Submit
          </>
        )}
        nextButtonAction={() => {
          if (!data.id) {
            tostW("Please submit basic details first!!");
            handleTab(1);
            return;
          }
          formik.validateForm().then(async (errors) => {
            const invalidBasicDetail = Object.keys(errors).filter((key) =>
              basicDetailValidation.includes(key)
            );
            if (invalidBasicDetail.length > 0) {
              tostW("Please complete this form accurately.");
              handleTab(1);
              setInValidForm(true);
              return;
            }
            if (Object.keys(errors).includes("director")) {
              tostW("Please complete this form accurately.");
              handleTab(2);
              setInValidForm(true);
              return;
            }
            const invalidFields = Object.keys(errors).filter((key) =>
              members_validation_fields.includes(key)
            );

            if (invalidFields.length > 0) {
              tostW("Please complete this form accurately.");
              handleTab(3);
              setInValidForm(true);
              return;
            } else {
              if (!consentInfo?.agree) {
                tostW("Please accept terms and conditions.");
                return;
              }
              let isvalid = await isMemberDetailsValid(values);
              if (!isvalid) {
                handleTab(3);
                setInValidForm(true);
                return;
              }
            }
            handleSubmit();
          });
        }}
      />
      {(draftSaved || draftError) && (
        <SaveAsDraftModal
          handleCloseModal={() => {
            setDraftSaved(false);
            setDraftError(false);
          }}
          error={draftError}
        />
      )}
      {showDisclaimer && (
        <Modal
          className="save-draft-modal "
          modalTitle="Confirmation"
          handleCloseModal={() => {
            setShowDisclaimer(false);
            setDisclaimerAcknowledgement(true);
          }}
          footerAction={() => {
            setShowDisclaimer(false);
            setDisclaimerAcknowledgement(true);
          }}
          footerActionActive
          footerActionText="Okay"
        >
          <img src={pendingIcon} alt="" />
          <h6 className="text-center">GST Information Required for Invoice</h6>
          <p className="text-center">
            Leaving the GST field blank means a GST invoice will not be issued
            for your Star Membership plan. Please ensure this aligns with your
            requirements.
          </p>
        </Modal>
      )}
      <PdfConsentModal
        isOpen={consentInfo?.consent_popup}
        pdfUrl={tncDoc}
        agreeConsent={() => {
          setConsentInfo((prev) => ({
            ...prev,
            consent_popup: false,
            agree: true,
            error: false,
          }));
        }}
      />
    </>
  );
}
